import axios from "@axios";

import { getSiteIdsForGroups } from "@/utils/store";

const DEFAULT_STATE = {
  sites: [],
  siteGroups: [],
  redacs: [],

  // BySource :
  yearDate: null,
  sourceId: [],
  listSourceId: [],
  exactSearch: false,
  containsSource: null,

  // PerfPerArticle / PerfPerCategory :
  categories: [],
  dates: [],
  periodType: "",
  statsForPeriod: {},

  // PerfPerArticle :
  searchType: "",
  searchColumn: "",
  frequency: "",

  // PerfPerCategory :
  excludeCategories: false,
  channels: [],
  channelList: [],

  //RentaPerArticle :
  rentaGlobalStats: {},
  monthDate: "",

  // ACPM :
  acpmIndicator: "",
  acpmIndicatorList: [],
  acpmBusinesses: [],
  acpmBusinessList: [],
  acpmSites: [],
  acpmSiteList: [],
  acpmThematics: [],
  acpmThematicList: [],
  acpmSubThematics: [],
  acpmSubThematicList: [],

  // GscCMonthly
  selectedGscDateRange: [],
  gscSourceType: "",
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getSites: (state) => state.sites,
    getSiteGroups: (state) => state.siteGroups,
    getRedacs: (state) => state.redacs,

    // BySource :
    getYearDate: (state) => state.yearDate,
    getSourceId: (state) => state.sourceId,
    getListSourceId: (state) => state.listSourceId,
    getExactSearch: (state) => state.exactSearch,
    getContainsSource: (state) => state.containsSource,

    // PerfPerArticle / PerfPerCategory :
    getCategories: (state) => state.categories,
    getDates: (state) => {
      if (state.dates.length !== 2) {
        return [];
      }
      // always return the dates ordered
      return state.dates[0] < state.dates[1]
        ? [state.dates[0], state.dates[1]]
        : [state.dates[1], state.dates[0]];
    },
    getPeriodType: (state) => state.periodType,
    getStatsForPeriod: (state) => state.statsForPeriod,

    // PerfPerArticle :
    getSearchType: (state) => state.searchType,
    getSearchColumn: (state) => state.searchColumn,
    getFrequency: (state) => state.frequency,

    // PerfPerCategory :
    getExcludeCategories: (state) => state.excludeCategories,
    getChannels: (state) => state.channels,
    getChannelList: (state) => state.channelList,

    //RentaPerArticle :
    getRentaGlobalStats: (state) => state.rentaGlobalStats,
    getMonthDate: (state) => state.monthDate,

    // ACPM :
    getAcpmIndicator: (state) => state.acpmIndicator,
    getAcpmIndicatorList: (state) => state.acpmIndicatorList,
    getAcpmBusinesses: (state) => state.acpmBusinesses,
    getAcpmBusinessList: (state) => state.acpmBusinessList,
    getAcpmSites: (state) => state.acpmSites,
    getAcpmSiteList: (state) => state.acpmSiteList,
    getAcpmThematics: (state) => state.acpmThematics,
    getAcpmThematicList: (state) => state.acpmThematicList,
    getAcpmSubThematics: (state) => state.acpmSubThematics,
    getAcpmSubThematicList: (state) => state.acpmSubThematicList,

    // GscCMonthly
    getSelectedGscDateRange: (state) => state.selectedGscDateRange,
    getGscSourceType: (state) => state.gscSourceType,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setRedacs(state, payload) {
      state.redacs = payload;
    },
    setSites(state, payload) {
      state.sites = payload;
    },
    setSiteGroups(state, payload) {
      state.siteGroups = payload;
    },

    // BySource :
    setYearDate(state, payload) {
      state.yearDate = payload;
    },
    setSourceId(state, payload) {
      state.sourceId = payload;
    },
    setListSourceId(state, payload) {
      state.listSourceId = payload;
    },
    setExactSearch(state, payload) {
      state.exactSearch = payload;
    },
    setContainsSource(state, payload) {
      state.containsSource = payload;
    },

    // PerfPerArticle / PerfPerCategory :
    setCategories(state, payload) {
      state.categories = payload;
    },
    setDates(state, payload) {
      state.dates = payload;
    },
    setPeriodType(state, payload) {
      state.periodType = payload;
    },
    setStatsForPeriod(state, payload) {
      state.statsForPeriod = payload;
    },

    // PerfPerArticle :
    setSearchType(state, payload) {
      state.searchType = payload;
    },
    setSearchColumn(state, payload) {
      state.searchColumn = payload;
    },
    setFrequency(state, payload) {
      state.frequency = payload;
    },

    // PerfPerCategory :
    setExcludeCategories(state, payload) {
      state.excludeCategories = payload;
    },
    setChannels(state, payload) {
      state.channels = payload;
    },
    setChannelList(state, payload) {
      state.channelList = payload;
    },

    //RentaPerArticle :
    setRentaGlobalStats(state, payload) {
      state.rentaGlobalStats = payload;
    },
    setMonthDate(state, payload) {
      state.monthDate = payload;
    },

    // ACPM :
    setAcpmIndicator(state, payload) {
      state.acpmIndicator = payload;
    },
    setAcpmIndicatorList(state, payload) {
      state.acpmIndicatorList = payload;
    },
    setAcpmBusinesses(state, payload) {
      state.acpmBusinesses = payload;
    },
    setAcpmBusinessList(state, payload) {
      state.acpmBusinessList = payload;
    },
    setAcpmSites(state, payload) {
      state.acpmSites = payload;
    },
    setAcpmSiteList(state, payload) {
      state.acpmSiteList = payload;
    },
    setAcpmThematics(state, payload) {
      state.acpmThematics = payload;
    },
    setAcpmThematicList(state, payload) {
      state.acpmThematicList = payload;
    },
    setAcpmSubThematics(state, payload) {
      state.acpmSubThematics = payload;
    },
    setAcpmSubThematicList(state, payload) {
      state.acpmSubThematicList = payload;
    },

    // GscCMonthly
    setSelectedGscDateRange(state, payload) {
      state.selectedGscDateRange = payload;
    },
    setGscSourceType(state, payload) {
      state.gscSourceType = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateSites({ commit }, payload) {
      commit("setSites", payload);
    },
    async updateSiteGroups({ commit }, payload) {
      commit("setSiteGroups", payload);

      const site_ids = await getSiteIdsForGroups(payload);
      commit("setSites", site_ids);

      return site_ids;
    },
    setRedacs(context, payload) {
      context.commit("setRedacs", payload);
    },

    // BySource :
    updateYearDate({ commit }, payload) {
      commit("setYearDate", payload);
    },
    updateSourceId({ commit }, payload) {
      commit("setSourceId", payload);
    },
    updateListSourceId({ commit }, payload) {
      commit("setListSourceId", payload);
    },
    updateExactSearch({ commit }, payload) {
      commit("setExactSearch", payload);
    },
    updateContainsSource({ commit }, payload) {
      commit("setContainsSource", payload);
    },

    // PerfPerArticle / PerfPerCategory :
    updateCategories({ commit }, payload) {
      commit("setCategories", payload);
    },
    updateDates({ commit }, payload) {
      if (payload.length >= 2) {
        commit("setDates", payload);
      }
    },
    updatePeriodType({ commit }, payload) {
      commit("setPeriodType", payload);
    },
    updateStatsForPeriod({ commit }, payload) {
      commit("setStatsForPeriod", payload);
    },

    // PerfPerArticle :
    updateSearchType({ commit }, payload) {
      commit("setSearchType", payload);
    },
    updateSearchColumn({ commit }, payload) {
      commit("setSearchColumn", payload);
    },
    updateFrequency({ commit }, payload) {
      commit("setFrequency", payload);
    },

    // PerfPerCategory :
    updateExcludeCategories({ commit }, payload) {
      commit("setExcludeCategories", payload);
    },
    async getChannelList({ commit }) {
      const { data } = await axios.get("/adn-post-channel/");
      commit("setChannelList", data);

      return data;
    },
    updateChannels({ commit }, payload) {
      commit("setChannels", payload);
    },

    //RentaPerArticle :
    updateRentaGlobalStats({ commit }, payload) {
      commit("setRentaGlobalStats", payload);
    },
    updateMonthDate({ commit }, payload) {
      commit("setMonthDate", payload);
    },

    // ACPM :
    async getAcpmIndicatorList({ commit }) {
      const { data } = await axios.get("/audience/acpm/indicators");
      commit("setAcpmIndicatorList", data);

      return data;
    },
    updateAcpmIndicator({ commit }, payload) {
      commit("setAcpmIndicator", payload);
    },
    async getAcpmBusinessList({ commit }) {
      const { data } = await axios.get("/audience/acpm/businesses");
      commit("setAcpmBusinessList", data);

      return data;
    },
    updateAcpmBusinesses({ commit }, payload) {
      commit("setAcpmBusinesses", payload);
    },
    async getAcpmSiteList({ commit }) {
      const { data } = await axios.get("/audience/acpm/sites");
      commit("setAcpmSiteList", data);

      return data;
    },
    updateAcpmSites({ commit }, payload) {
      commit("setAcpmSites", payload);
    },
    async getAcpmThematicList({ commit }) {
      const { data } = await axios.get("/audience/acpm/thematics");
      commit("setAcpmThematicList", data);

      return data;
    },
    updateAcpmThematics({ commit }, payload) {
      commit("setAcpmThematics", payload);
    },
    async getAcpmSubThematicList({ commit }) {
      const { data } = await axios.get("/audience/acpm/sub-thematics");
      commit("setAcpmSubThematicList", data);

      return data;
    },
    updateAcpmSubThematics({ commit }, payload) {
      commit("setAcpmSubThematics", payload);
    },

    // gscMonthly
    updateSelectedGscDateRange({ commit }, payload) {
      commit("setSelectedGscDateRange", payload);
    },
    updateGscSourceType({ commit }, payload) {
      commit("setGscSourceType", payload);
    },
  },
};
